import { useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Anatomy from "@/components/Anatomy";
import Benefits from "@/components/Benefits";
import UseCases from "@/components/UseCases";
import Packs from "@/components/Packs";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import CheckoutDrawer from "@/components/CheckoutDrawer";
import ChatWidget from "@/components/ChatWidget";

export default function Home() {
    const [checkoutPack, setCheckoutPack] = useState(null);
    return (
        <div className="bg-cream text-ink font-sans overflow-x-clip grain" data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Manifesto />
                <Anatomy />
                <Benefits />
                <UseCases />
                <Packs onSelect={setCheckoutPack} />
                <Testimonials />
                <Faq />
            </main>
            <Footer />
            <CheckoutDrawer pack={checkoutPack} onClose={() => setCheckoutPack(null)} />
            <ChatWidget />
        </div>
    );
}
